import React, { memo } from 'react'
import { Box } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { CheckFilledIcon, CheckOutlineIcon, GlobeIcon, DryVanIcon } from 'transfix-icons'
import { TableRow, TableCell } from 'transfix-ui'
import { DISPLAY } from 'constants/display'

interface ISpotBiddingRulesRowProps {
  id: string
  isChecked: boolean
  isGlobal: boolean
  premiumOrCostApplied: string
  ruleType: string
  ruleDetail: string
  ruleSubDetail?: string
  ruleLocation: string
}

export const SpotBiddingRulesRow = memo<ISpotBiddingRulesRowProps>(
  ({
    id,
    isChecked,
    isGlobal,
    premiumOrCostApplied,
    ruleDetail,
    ruleLocation,
    ruleSubDetail,
    ruleType,
  }) => {
    return (
      <TableRow>
        <TableCell key={`${id}-status-column-value`}>
          {isChecked ? (
            <CheckFilledIcon size='large' color='skyBlue6' />
          ) : (
            <CheckOutlineIcon size='large' color='coolGray3' />
          )}
        </TableCell>
        <TableCell key={`${id}-premium-column-value`}>{premiumOrCostApplied}</TableCell>
        <TableCell key={`${id}-rule-column-value`}>
          <Box display='flex' alignItems='center'>
            <Box mr={1}>{isGlobal ? <GlobeIcon size='large' /> : <DryVanIcon size='large' />}</Box>
            <div>{ruleType}</div>
          </Box>
        </TableCell>
        <TableCell key={`${id}-detail-column-value`}>
          {ruleDetail || DISPLAY.empty}
          {ruleSubDetail && <div style={{ color: brandColors.coolGray5 }}>{ruleSubDetail}</div>}
        </TableCell>
        <TableCell key={`${id}-rule-location`}>{ruleLocation}</TableCell>
      </TableRow>
    )
  }
)
